// ----------------------------------------------------
// src/Redux/Slices/ContactSlice.js
// ----------------------------------------------------

import { createSlice } from "@reduxjs/toolkit";
import ContactData from "../../Json/ContactData.json";

const initialState = {
  contact: ContactData,
};

const ContactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
});

export default ContactSlice.reducer;